import { ResponseBase } from '../response-base.model';
import { Seccion } from './seccion.model';
export class ListadoSecciones extends ResponseBase {
    idEncuesta: number;
    secciones: Array<Seccion> = [];
}
